// extracted by mini-css-extract-plugin
export default {"link":"AN-z","disabled":"BN-z"};